export default __webpack_public_path__ + "static/media/detail_main_img_15.c5b79828.png";